import { Component, OnInit } from '@angular/core'
import { MatTabsModule } from '@angular/material/tabs'
import { MatTooltipModule } from '@angular/material/tooltip'
import { SupplierPortalOsListComponent } from '../supplier-portal-os-list/supplier-portal-os-list.component'
import { SupplierPortalQuoteListComponent } from '../../../features/supplier-portal/supplier-portal-quote-list/supplier-portal-quote-list.component'
import { SupplierPortalQuoteService } from '../../../core/services/supplier-portal/supplier-portal-quote.service'
import { FornecedorCotacaoPortalVm } from '../../../core/models/supplier-portal.model'
import {
  podeResponder,
  STATUS_ITEM,
} from '../../../features/supplier-portal/supplier-portal-quote-status.util'

// Container das abas do Portal do Fornecedor. Substituiu a listagem de OS como componente da
// rota raiz quando o portal ganhou a aba de cotação — a listagem de OS virou conteúdo de aba.
@Component({
  selector: 'supplier-portal-home',
  standalone: true,
  imports: [
    MatTabsModule,
    MatTooltipModule,
    SupplierPortalOsListComponent,
    SupplierPortalQuoteListComponent,
  ],
  templateUrl: './supplier-portal-home.component.html',
  styleUrl: './supplier-portal-home.component.scss',
})
export class SupplierPortalHomeComponent implements OnInit {
  constructor(private supplierPortalQuoteService: SupplierPortalQuoteService) {}

  // A aba de cotações só busca a listagem paginada quando o fornecedor entra nela pela
  // primeira vez; a contagem do badge é carregada sempre, senão ele não teria função.
  quoteTabLoaded = false
  pendingCount = 0

  ngOnInit() {
    this.loadPendingCount()
  }

  onTabChange(index: number) {
    if (index === 1) {
      this.quoteTabLoaded = true
    }
  }

  // O endpoint filtra só por statusId, e um trecho pode estar em "Enviado Fornecedor" com a
  // cotação já finalizada pelo operador — esse não é respondível. Por isso a contagem vem do
  // podeResponder, e não do totalItens da resposta.
  loadPendingCount() {
    this.supplierPortalQuoteService
      .listPagedCotacoes(1, 999, STATUS_ITEM.ENVIADO_FORNECEDOR)
      .subscribe({
        next: (response: any) => {
          const itens: FornecedorCotacaoPortalVm[] = response?.data ?? []
          this.pendingCount = itens.filter((item) => podeResponder(item)).length
        },
        error: () => {
          this.pendingCount = 0
        },
      })
  }
}
